var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoBetIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.0002,
    r: 14,
    transform: "rotate(90 15 15.0002)",
    fill: "var(--selectBg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25C9.47715 25 5 20.5228 5 15C5 9.47715 9.47715 5 15 5C20.5228 5 25 9.47715 25 15C25 20.5228 20.5228 25 15 25ZM16.3264 9.71275C18.8451 10.1672 20.75 12.3854 20.75 15.0437C20.75 16.6212 20.0791 18.0431 19.0093 19.0328C18.7052 19.3141 18.2307 19.2956 17.9494 18.9915C17.6682 18.6875 17.6866 18.213 17.9907 17.9317C18.765 17.2154 19.25 16.1879 19.25 15.0437C19.25 13.2056 17.9979 11.6697 16.3147 11.2445L16.5414 11.4809C16.828 11.7799 16.818 12.2547 16.5191 12.5414C16.2201 12.828 15.7453 12.818 15.4586 12.5191L13.9031 10.8966C13.7619 10.7493 13.6867 10.5508 13.6951 10.347C13.7034 10.1431 13.7944 9.95137 13.9472 9.81608L15.5028 8.43852C15.8129 8.16391 16.2869 8.19267 16.5615 8.50277C16.8361 8.81286 16.8073 9.28686 16.4972 9.56148L16.3264 9.71275ZM16.0528 20.1795C16.2053 20.044 16.296 19.8523 16.3041 19.6485C16.3122 19.4447 16.2369 19.2464 16.0956 19.0993L14.5409 17.4805C14.254 17.1817 13.7792 17.1721 13.4805 17.4591C13.1817 17.746 13.1722 18.2208 13.4591 18.5195L13.6807 18.7503C12.0009 18.322 10.7491 16.7819 10.7491 14.9348C10.7491 13.792 11.2286 12.7655 11.9943 12.0469C12.2963 11.7634 12.3114 11.2888 12.0279 10.9868C11.7445 10.6847 11.2698 10.6697 10.9678 10.9531C9.91048 11.9454 9.24913 13.3635 9.24913 14.9348C9.24913 17.6011 11.1542 19.8295 13.6766 20.2841L13.5019 20.4393C13.1922 20.7144 13.1642 21.1885 13.4393 21.4981C13.7144 21.8078 14.1885 21.8358 14.4981 21.5607L16.0528 20.1795Z",
    fill: "var(--primaryButtonBg)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoBetIconActive);
export default __webpack_public_path__ + "static/media/auto-bet-icon-active.ab71ed1c67d7c3ec430e5eb4eb81f88c.svg";
export { ForwardRef as ReactComponent };